//-- Copyright (c) 2021 TMT Insights Group, LLC
import React, { ReactNode } from 'react';
import { Typography, Box, TypographyTypeMap } from '@mui/material';
import styled from '@emotion/styled';
import { convertStylesToStyled } from '@/_utils/utils';

type TabHeadingProps = {
  icon?: ReactNode;
  variant?: TypographyTypeMap['props']['variant'];
  children?: ReactNode;
};

const TabHeading = ({ icon, variant = 'h2', children }: TabHeadingProps) => (
  <Heading>
    {icon && <HeadingIcon>{icon}</HeadingIcon>}
    <Typography variant={variant}>{children}</Typography>
  </Heading>
);

export default TabHeading;

const Heading = styled(Box)`
  display: flex;
  align-items: center;
  font-size: 1.33rem;
  margin-bottom: ${({ theme }) => theme.spacing(5)};
  line-height: 1.5;

  & .MuiTypography-root {
    font-size: 1.2rem;
  }

  ${({ theme }) => convertStylesToStyled(theme.customOverrides?.TabHeading)}
`;

const HeadingIcon = styled.span`
  margin-right: ${({ theme }) => theme.spacing(1.5)};
  color: ${({ theme }) => theme.palette.primary.main};
  line-height: 1;
  display: inline-flex;
`;
